<template>
  <div id="main">
    <div class="sections">
      <SectionTitle />
      <SectionBenefit />
      <SectionReason />
      <SectionProcess />
      <SectionReview />
      <SectionFaq />
      <SectionFooter />
    </div>
    <div class="button">
      <button
        class="btn-kakao slow"
        @click="signinKakao"
        v-inview:animate="'fadeInUp'"
      >
        카카오 로그인
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/design/_colors.scss';
#main {
  background-color: white;

  .sections {
    position: relative;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 2;
    float: left;
  }

  .button {
    position: fixed;
    display: flex;
    bottom: 30px;
    width: 100%;
    margin: auto 0;
    z-index: 1000;
    align-content: center;
    justify-content: center;

    button.btn-kakao {
      width: calc(335% / 375 * 100);
      max-width: 600px;
      height: 64px;
      color: #252525;
      background-color: $yellow;
      font-size: 20px;
      font-weight: 900;
      border-radius: 32px;
      box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);
      img {
        width: 17px;
        margin-left: 5px;
      }
    }

    button.btn-kakao:before {
        display: inline-block;
        content: "";
        background: url('../../assets/images/kakao_symbol.svg') no-repeat 50%;
        background-size: contain;
        margin-right: 4px;
        width: 22px;
        height: 22px;
        vertical-align: middle;
    }
  }
}
</style>

<script>
import AuthService from '@/service/auth/AuthService'
import ChannelService from '@/service/channeltalk/ChannelService'
import SectionTitle from './components/SectionTitle'
import SectionBenefit from './components/SectionBenefit'
import SectionProcess from './components/SectionProcess'
import SectionReason from './components/SectionReason'
import SectionReview from './components/SectionReview'
import SectionFaq from './components/SectionFaq'
import SectionFooter from './components/SectionFooter'

let debug = false
let self

export default {
  components: {
    SectionTitle,
    SectionBenefit,
    SectionProcess,
    SectionReason,
    SectionReview,
    SectionFaq,
    SectionFooter,
  },
  data() {
    return {
      signinLoading: false,
      timeoutClear: null,
    }
  },
  async created() {
    self = this
    ChannelService.boot()
    if (window.location.host === 'now.funda.kr') {
      window.fbq('track', 'ViewContent')
    }
    let token = this.$route.query.secret_token
    if (token) {
      window.tokenlogin(token)
      return
    }

    // 카카오 토큰 url에 입력 후에 중간 과정 생략하고 첫 페이지로 redirect
    let passCode = this.$route.query.pass_code
    if (passCode) {
      this.signin()
      return
    }
    // Check Code
    try {
      // Code Signin
      let code = this.$route.query.code
      if (code) {
        if (code === localStorage.getItem('kakaocode')) {
          return
        }
      } else {
        return
      }
      let res = await AuthService.signinCode(code) // 코드 로그인
      if (!res) return
      await this.signin() // 로그인 성공
    } catch (e) {
      // Token Signin
      setTimeout(function () {
        self.signinKakaoToken()
      }, 500) // 토큰 로그인
    }
  },
  destroyed() {
    clearTimeout(this.timeoutClear)
  },
  methods: {
    // Token
    async signinKakaoToken() {
      if (debug) {
        console.log('signinKakaoToken')
      }
      let res = await AuthService.getKakaoToken()
      if (!this._.get(res, 'access_token')) {
        return
      }
      await AuthService.signinKakaoToken(res.access_token)
      this.signin() // 로그인 성공
    },
    // Code
    async signinKakaoCode() {
      if (debug) {
        console.log('signinKakaoCode')
      }
      await AuthService.getKakaoCode()
    },
    async signinKakao() {
      if (debug) {
        console.log('signinKakao')
      }
      try {
        this.signinKakaoCode() // 코드 로그인
      } catch (e) {
        self.signinKakaoToken() // 토큰 로그인
      } finally {
        // UTM
        await AuthService.sendUtmCookies()
      }
    },
    async signin() {
      if (debug) {
        console.log('signin')
      }
      await AuthService.syncProfile()
      ChannelService.boot()
      // Redirect Uri
      let redirectUri = this.$route.query.redirectUri
      if (redirectUri == null) {
        await this.$router.push({ name: 'dashboard' })
      } else {
        await this.$router.push({ path: redirectUri })
      }
    },
  },
}
</script>
